var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.4,21.3h11.2c0.3,0,0.6-0.1,0.9-0.3c2.7-2.2,4.3-5.7,3.8-9.5c-0.6-4.6-4.4-8.3-9.1-8.8 C6.9,2,1.6,6.8,1.6,12.9c0,3.3,1.5,6.2,3.9,8.1C5.8,21.2,6.1,21.3,6.4,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.7,18.5H9.3c-1.4,0-2.5-1.1-2.5-2.5V9.7c0-1.4,1.1-2.5,2.5-2.5h5.4c1.4,0,2.5,1.1,2.5,2.5V16 C17.2,17.4,16.1,18.5,14.7,18.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 11,
    y1: 9.6,
    x2: 13,
    y2: 9.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 6.9,
    y1: 13.7,
    x2: 17.1,
    y2: 13.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.7,
    cy: 16.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.2,
    cy: 16.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 15.3,
    y1: 18.4,
    x2: 18,
    y2: 21.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.6,
    y1: 18.4,
    x2: 5.7,
    y2: 21.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubway);
export default __webpack_public_path__ + "static/media/subway.45820f8e4636121894f5d1b14bafee63.svg";
export { ForwardRef as ReactComponent };